import React, { useEffect, useState, useRef } from "react";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import '../menu.css'
import { Ripple } from "primereact/ripple";
import { LoginResponse } from "../../../models/index";
import { wglcsApiService } from "../../../services/WglcsApiService";
import _ from "lodash";
import moment from "moment";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column'
import { Skeleton } from "primereact/skeleton";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import * as XLSX from 'xlsx';
import { ProgressSpinner } from "primereact/progressspinner";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import EventEmitter, { Events } from "../../../services/eventemitter";
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { t } from "i18next";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const NoAgentChatsReport = () => {
    const tableRef = useRef(null);
    var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse
    const fDate = new Date();
    fDate.setDate(fDate.getDate() - 5);
    const [fromDate, setFromDate] = useState<any>(fDate);
    const [toDate, setToDate] = useState<any>(new Date());
    const [selectedCompanyName, setSelectedCompanyName] = useState<any>(null);
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [selectedTimeZone, setSelectedTimeZone] = useState<any>(null);
    const [loadingCompanies, setLoadingCompanies] = useState(true)
    const [CompanyArray, setCompanyArray] = useState([])
    const [WebsiteArray, setWebsiteArray] = useState<any>([])
    const [TimeArray, setTimeArray] = useState<any>([])
    const [searchText, setSearchText] = useState("")
    const [agentChatData, setAgentChatData] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [timeloading, setTimeLoading] = useState(true)
    const [defaultTime, setDefaultTime] = useState<any>(null);
    const timeZoneRef = useRef<any>(null);
    const CompanyRef = useRef<any>(null);
    const [hidebutton, setHideButton] = useState(true)
    const [refreshState, setRefreshState] = useState<any>(new Date())
    const [filters, setFilters] = useState({
        "global": { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const skeletonLength = [
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
    ]
    useEffect(() => {
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, [])
    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime())
    }
    useEffect(() => {
        ApiCalls()
    }, [])

    useEffect(() => {
        timeZone()
    }, [selectedWebsite])

    const ApiCalls = async () => {
        loadCompanies()
        timeZone()
    };
    const loadCompanies = async () => {
        let apiResponse = await wglcsApiService.getallCompaniesbyEmployeeCompanyid(userData?.userLoginData?.empCompId.toString());
        var arr = _.orderBy(apiResponse?.data?.data, ["companyName"], ["asc"]);
        setCompanyArray(arr as any)
        setLoadingCompanies(false)
    };
    const timeZone = async () => {
        let apiResponse = await wglcsApiService.GetAllReportingTimeZones();
        if (apiResponse) {
            setTimeLoading(false)
            if (selectedWebsite != null) {
                var data = apiResponse.data.filter(m => m.standardName == selectedWebsite.timeZone)
                if (data.length > 0) {
                    setTimeArray(apiResponse.data)
                    setSelectedTimeZone(data[0])
                    setDefaultTime(data[0])
                } else {
                    var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
                    setTimeArray(apiResponse.data)
                    setSelectedTimeZone(data[0])
                    setDefaultTime(data[0])
                }
            }
            else {
                var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
                setTimeArray(apiResponse.data)
                setSelectedTimeZone(data[0])
                setDefaultTime(data[0])
            }
        }
    }
    const onTimeChange = (e) => {
        setSelectedTimeZone(e.value);
    }
    const commonRequestData = () => {
        return {
            fromDate: moment(fromDate).format("YYYY-MM-DD"),
            toDate: moment(toDate).format("YYYY-MM-DD"),
            companyId: selectedCompanyName?.companyId,
            websiteId: selectedWebsite?.websiteId,
            timeZone: selectedTimeZone?.standardName,
            timeType: "",
            agentId: "",
            chatCountBy: "",
            timeFrom: "",
            timeTo: "",
            region: "",
            leadType: "",
            chatAdvanceFilter: "",
            chatId: "",
            location: "",
            reportType: ""
        };
    };
    const fromData = (e) => {
        setFromDate(e.value)
    }
    const toData = (e) => {
        setToDate(e.value)
    }
    const searchClear = () => {
        setSearchText("")
        setFilters({
            "global": { value: null, matchMode: FilterMatchMode.CONTAINS }
        })
    }
    const handleSearch = (e) => {
        const value = e.target.value;
        let _filters1 = { ...filters };
        _filters1['global'].value = value;
        setFilters(_filters1);
        setSearchText(value)
    }
    const AgentChat_API = async () => {
        var result = await wglcsApiService.noofchatsbyagents(commonRequestData())
        if (result.data.data) {
            setAgentChatData(result.data.data)
        } else {
            setAgentChatData([])
        }
        setLoading(false)
    }
    const submit = () => {
        if (!selectedCompanyName) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t('toast.Company-validation'))
            return;
        }
        else {
            setLoading(true)
            AgentChat_API()
            setHideButton(false)
        }
    }
    const onCompanyChange = (e) => {
        setSelectedCompanyName(e.value);
        loadWebsites(e.value.companyId);
    }
    const onWebsiteChange = (e) => {
        setSelectedWebsite(e.value);
        timeZoneRef?.current.resetFilter();
    }
    const loadWebsites = async (id) => {
        let response = await wglcsApiService.getwebsitebycompanyId(id);
        var data = response.data.data.filter(m => m.status === true)
        setWebsiteArray(data)
        setSelectedWebsite(data[0])
    };
    const CompanyOptionTemplate = (option) => {
        if (loadingCompanies) {
            return (
                <div style={{ margin: "2px" }} >
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.companyName}</div>
                </div>
            );
        }
    };


    const renderSearchField = () => {
        return (
            <div className="search-view">
                <input
                    className="searchfeild"
                    value={searchText}
                    onChange={handleSearch}
                    placeholder={t("Search")}
                />
                <i className="fa-light fa-search search-icon"></i>
                {searchText.length > 0 && <i onClick={searchClear} className="fa fa-times clear-icon"></i>}
            </div>
        )
    }
    const exportSelectedWebsite = () => {
        if (selectedWebsite) {
            return selectedWebsite?.domainName + " " + "(" + t('From') + ":" + moment(fromDate).format("MM-DD-YYYY") + " " + t("To") + ":" + moment(toDate).format("MM-DD-YYYY") + ")"
        } else {
            return ""
        }
    }
    const TimeTemplate = (option) => {
        if (timeloading) {
            return (
                <div style={{ margin: "2px" }} >
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.displayName}</div>
                </div>
            );
        }
    };

    const ExportPDF = () => {
        const doc = new jsPDF() as any
        const pdfWidth = doc.internal.pageSize.getWidth();
        const logoWidth = 45;
        const logoHeight = 15;
        const logoY = 5;
        const centerX = (pdfWidth - logoWidth) / 2;
        const imageElement = document.getElementById('logoImage');
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx?.drawImage((imageElement as any), 0, 0, canvas.width, canvas.height);
        const imgData = canvas.toDataURL('image/svg');
        doc.addImage(imgData, 'SVG', centerX, logoY, logoWidth, logoHeight);
        doc.setFontSize(12)
        const text = "No of Chats by Agent Report";
        const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const textX = (pdfWidth - textWidth) / 2;
        doc.text(text, textX, 35);
        doc.text(52, 42, exportSelectedWebsite())
        const headers = [["Agent Name", "Total Chats"]]
        const data = [...agentChatData.map(item =>
            [
                item.userName,
                item.totalChats,
            ])]
        const tableProps = {
            startY: 48,
            head: headers,
            body: [...data],
            headStyles: {
                fontSize: 10, // Adjust the font size
                fontStyle: 'normal', // Set fontStyle to 'normal' for regular text
                fillColor: [78, 134, 199], // Adjust the header background color to #4e86c7
                textColor: 255, // Adjust the header text color to white
                cellPadding: 2, // Adjust the padding of header cells
                lineColor: [0, 0, 0], // Adjust the color of lines between header cells
                halign: 'center'
            },
            bodyStyles: {
                fontSize: 8, cellPadding: 2
            },
            columnStyles: { 0: { cellWidth: 90, halign: 'center' }, 1: { cellWidth: 90, halign: 'center' } }
        };
        doc.autoTable(tableProps);
        doc.save("No of Chats by Agent Report")
    }
    const renderLoader = () => {
        return (
           
                <ProgressSpinner strokeWidth="3" fill="#EEEEEE" animationDuration=".5s" />
          
        );
    }
    return (
        <><img id="logoImage" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="" style={{ display: 'none' }} />
            <div className="wgReoprts-container">
                <div className="row p-2">
                    <div className="wgreport-tab viewreport-box">
                        <div className="row view-wgreport">
                            <div className="col-md-3 col-lg-3 py-1 wgreport" >
                                <label className="wgreport-label" htmlFor="firstname6">{t('smtp-DataTable.Company-Name')}</label>
                                <div className="spinner-box">
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="companyName"
                                    value={selectedCompanyName}
                                    options={CompanyArray}
                                    onChange={onCompanyChange}
                                    optionLabel="companyName"
                                    placeholder={!loadingCompanies ? t('fieldsPlaceholder.selectCompany') : selectedCompanyName}
                                // itemTemplate={CompanyOptionTemplate}
                                // ref={CompanyRef}
                                />
                                {loadingCompanies && renderLoader()}
                                </div>
                            </div>
                            <div className="col-md-3 col-lg-3 py-1 wgreport" >
                                <label className="wgreport-label" htmlFor="basic">{t('MonitoringPanel 6erComponent.Website-Name')}</label>
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="domainName"
                                    value={selectedWebsite}
                                    options={WebsiteArray}
                                    onChange={onWebsiteChange}
                                    optionLabel="domainName"
                                    placeholder={t('ReportComponent.Select Website')} />
                            </div>
                            <div className="col-md-3 col-lg-3 py-1 wgreport" >
                                <label className="wgreport-label" htmlFor="firstname6">{t('ChatTranscriptComponent.From Date')}</label>
                                <Calendar showIcon value={fromDate} onChange={(e) => fromData(e)}
                                    minDate={new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1)}
                                    maxDate={new Date()}
                                />
                            </div>
                            <div className="col-md-3 col-lg-3 py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.To Date')}</label>
                                <Calendar id="abc" showIcon value={toDate} onChange={(e) => toData(e)}
                                    maxDate={new Date()}
                                    minDate={new Date(fromDate.getFullYear(), fromDate.getMonth(), 1)}
                                />
                            </div>
                       
                            <div className="col-md-3 col-lg-3  py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">{t('ManagePoc-DataTable.Time-Zone')}</label>
                                <div className="spinner-box">
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="displayName"
                                    value={selectedTimeZone}
                                    options={TimeArray}
                                    onChange={onTimeChange}
                                    optionLabel="displayName"
                                    // itemTemplate={TimeTemplate}
                                    placeholder={!timeloading ? t('ManagePoc-DataTable.Select-TimeZone') : selectedTimeZone}
                                // ref={timeZoneRef}
                                />
                                {timeloading && renderLoader()}
                                </div>
                            </div>
                            <div className="col-md-9 py-1 text-right text-md-left">
                                {hidebutton == false ? <>  <span title={t('wg-buttons.Export-Excel')}>
                                    <ReactHTMLTableToExcel
                                        id="test-table-xlsx-button search-btn"
                                        className="btn-width wgreport-btn wgbtn p-ripple"
                                        table="table-to-xlsx"
                                        filename="No of chats by Agent (Website Wise)"
                                        sheet="No of chats by Agent"
                                        buttonText={t('wg-buttons.Export-Excel')}
                                    /></span>
                                    <button title={t('wg-buttons.Export-PDF')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => ExportPDF()}> <Ripple />{t('wg-buttons.Export-PDF')}</button>
                                </> : ""}
                                <button title={t('wg-buttons.View-Report')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => submit()}> <Ripple />{t('wg-buttons.View-Report')}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="wgreport-span">{t("DashboardReports.NoofchatsbyAgent(Website Wise)")}</div>
                        <div className="wgreport-span">{exportSelectedWebsite()}</div>
                    </div>
                </div>
                <div className="row search-box">
                    <div className="col-12">{renderSearchField()}</div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {loading == true ?
                            <ProgressSpinner
                                style={{ width: "50px", marginLeft: "50%", marginTop: "10%" }}
                                strokeWidth="3"
                                fill="#EEEEEE"
                                animationDuration=".5s"
                            /> :
                            <div className='visitor-data-table'>
                                <DataTable value={agentChatData}
                                  
                                    filterDisplay="menu"
                                    className="p-datatable-lg p-datatable-responsive-demo"
                                    emptyMessage={t('resourcesPoolTable.Data Not Found')}
                                    filters={filters}
                                    paginator
                                    rows={20}
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                    rowsPerPageOptions={[20, 40, 60]}
                                >
                                    <Column field="userName" header={t("DashboardReport-dataTable.Agent-Name")} sortable></Column>
                                    <Column field="totalChats" header={t('ReportComponent.Total Chats')} sortable></Column>
                                </DataTable>
                            </div>
                        }
                    </div>
                    <div className='htmltable' style={{ display: 'none' }}>
                        {agentChatData && <table id="table-to-xlsx" ref={tableRef}>
                            <thead>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td style={{ fontSize: "18px", color: "black", textAlign: "center", fontWeight: 600 }} colSpan={2}>No of chats by Agent (Website Wise)</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <th style={{ fontSize: "14px", color: "black", textAlign: "center", fontWeight: 400 }} colSpan={3}>{exportSelectedWebsite()}</th>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                        Agent Name
                                    </th>
                                    <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                        {t('ReportComponent.Total Chats')}
                                    </th>
                                </tr>
                                {agentChatData.map((item, index) => (
                                    <tr key={index}>
                                        <td>&nbsp;</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.userName}</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.totalChats}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>}
                    </div>
                </div>
            </div >
        </>
    )
}
export default NoAgentChatsReport